// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31KLB","buttons":"Footer_buttons__2mbPw"};